import {
  isRequired,
  isValidUploadedImageSize,
  isValidUploadedImageFormat,
  isNumber
} from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.coverPhoto) {
    if (isRequired(values.coverPhoto.image || '', true)) {
      errors.coverPhoto = 'Cover photo is required';
    } else if (isValidUploadedImageSize(values.coverPhoto || '', true)) {
      errors.coverPhoto = 'Your file exceeded the size limit';
    } else if (isValidUploadedImageFormat(values.coverPhoto || '', true)) {
      errors.coverPhoto = `File could not be uploaded because the format is not supported. Please upload the file with the format png, jpg, jpeg`;
    }
  } else {
    errors.coverPhoto = 'Cover photo is required';
  }

  if (isRequired(values.title || '', true)) {
    errors.title = 'Title is required';
  }

  if (isNumber(values.guests, true)) {
    errors.guests = 'Guests are required';
  }

  if (isRequired(values.location || '', true)) {
    errors.location = 'Location is required';
  }

  if (isRequired(`${values.minNights || ''}`, true)) {
    errors.minNights = 'Nights are required';
  } else if (values.minNights < 1) {
    errors.minNights = 'Minimum 1 night';
  }

  return errors;
};

export default validate;
